export default __webpack_public_path__ + "static/media/ErrorIcon.403e79a7.svg";